import React from 'react';
import "../MaturityInstructionForm/maturityInstructionForm.scss"
import selectedIconV1 from "../../assets/images/Selected-dotV1.svg"
import selectedIcon from "../../assets/images/Selected-dot.svg"
import unselectedIcon from "../../assets/images/unselected-grey.svg"
import unselectedIconV1 from "../../assets/images/unselected-greyV1.svg"
/** @import {RadioButtonProps} from './RadioButtonTypes' */

function RadioButton(/** @type {RadioButtonProps} */ {
    value,
    chosenOption,
    classNameOverride,
    disabled,
    content,
    handleChange,
    hideIconWhenDisabled = true
}) {
    const selected = value === chosenOption;
    const className = classNameOverride? classNameOverride : "maturity3"

    const icon = () => {
        const iconName = selected && !disabled ? selectedIconV1 : unselectedIconV1

        if (!disabled || !hideIconWhenDisabled) {
            return <img src={iconName} style={{height: "24px", width: "24px"}} className={`${className}__inline-icon`}/>   
        }
        return null
    }
    
    return <label className={`${className}__radio-button ` + (disabled && ` ${className}__radio-button--disabled`)}>
        {icon()}
        <input type="radio" value={value} id={value}
            onChange={handleChange} name="rollOverOptions" disabled={disabled}/>
        <>{content}</>
    </label>
}

export default RadioButton